import React from "react"
import {connect} from "react-redux"
import {createStructuredSelector} from "reselect"
import {Body} from "../components/Body"
import {Firebase} from "../components/Firebase"
import ShareTaxTheme from "../projects/shareTax/theme"

class ShareTax extends React.Component {
  componentDidMount() {
    this.firebase = new Firebase()
  }

  render() {
    return <Body theme={ShareTaxTheme}>ShareTax</Body>
  }
}

const createSelectors = createStructuredSelector({})

export default connect(createSelectors, {})(ShareTax)
